import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import elementSettings from 'src/js/modules/element-settings';
import useAutoPaddingSync from '../hooks/use-auto-padding-sync';

const {
  Context: ElementSettingsContext,
  components: { ColorSchemeControl: CommonColorSchemeControl },
  helpers: { createBatch, combineBatches, convertPlainBatchToBreakpointBasedBatch },
} = elementSettings;

function ColorSchemeControl({ onChange, ...controlProps }) {
  const { deviceMode } = useContext(ElementSettingsContext);
  const { getAutoPaddingBatch } = useAutoPaddingSync();

  const handleChange = useCallback(
    ({ controlId, elementIds, targets, value, skipTracking = false }) => {
      const breakpointBasedBatch = convertPlainBatchToBreakpointBasedBatch(
        createBatch({ elementIds, targets, value }),
        deviceMode.breakpointKey
      );

      onChange({
        batch: combineBatches([
          breakpointBasedBatch,
          getAutoPaddingBatch(breakpointBasedBatch, { elementIds }),
        ]),
        controlId,
        skipTracking,
      });
    },
    [deviceMode.breakpointKey, getAutoPaddingBatch, onChange]
  );

  return <CommonColorSchemeControl {...controlProps} onChange={handleChange} />;
}

ColorSchemeControl.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default ColorSchemeControl;
